if (!process.env.REACT_APP_API_URL) {
  console.error('❌ REACT_APP_API_URL not set in .env');
}

export const API_BASE_URL = process.env.REACT_APP_API_URL;

/** Shown in UI and mailto fallback; Web3Forms deliveries should target this inbox */
export const CONTACT_EMAIL = 'info@filmudb.lt';

// Google OAuth configuration
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

export const API_TIMEOUTS = {
  DEFAULT: 30000,
  LONG: 60000,
  SHORT: 10000,
};

export const CACHE_CONFIG = {
  TIMEOUT: 30000,
  BATCH_TIMEOUT: 100,
  STALE_TIME: 5 * 60 * 1000,
  GC_TIME: 30 * 60 * 1000,
};

export const REQUEST_CONFIG = {
  RETRY_COUNT: 2,
  RETRY_DELAY: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  REFETCH_ON_WINDOW_FOCUS: false,
  REFETCH_ON_MOUNT: false,
};

export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 20,
  MAX_PAGE_SIZE: 100,
};

export const GTM_CONFIG = {
  GTM_ID: process.env.REACT_APP_GTM_ID || '',
  ENABLED: !!process.env.REACT_APP_GTM_ID,
};

export const ANALYTICS_EVENTS = {
  PAGE_VIEW: 'page_view',
  CONTENT_INTERACTION: 'content_interaction',
  USER_ACTION: 'user_action',
  SEARCH: 'search',
  CONVERSION: 'conversion',
  ERROR: 'error',
};

export const INTERACTION_TYPES = {
  VIEW_DETAIL: 'view_detail',
  ADD_TO_WATCHLIST: 'add_to_watchlist',
  REMOVE_FROM_WATCHLIST: 'remove_from_watchlist',
  ADD_TO_FAVORITES: 'add_to_favorites',
  REMOVE_FROM_FAVORITES: 'remove_from_favorites',
  MARK_AS_WATCHED: 'mark_as_watched',
  RATE_CONTENT: 'rate_content',
  PLAY_TRAILER: 'play_trailer',
};

export const RATINGS_CONFIG = {
  MIN_VOTE_COUNT: 3000,
  BULK_FETCH_ENABLED: true,
  CACHE_TIME: 10 * 60 * 1000,
  MIN_IMDB_RATING: 0,
  MAX_IMDB_RATING: 10,
  MIN_RT_RATING: 0,
  MAX_RT_RATING: 100,
  MIN_TMDB_RATING: 0,
  MAX_TMDB_RATING: 10,
};

// MDBList collection configuration
// Format: username/listname
export const MDBLIST_COLLECTIONS = {
  MOVIES: process.env.REACT_APP_MDBLIST_MOVIES_LIST || 'dominikkq/front-page',
  TV_SHOWS: process.env.REACT_APP_MDBLIST_TV_LIST || 'garycrawfordgc/latest-tv-shows',
};

export const RATING_COLORS = {
  IMDB: {
    BG: 'bg-yellow-600/20',
    TEXT: 'text-yellow-400',
    ICON: 'text-yellow-400',
  },
  RT_FRESH: {
    BG: 'bg-red-600/20',
    TEXT: 'text-red-400',
    ICON: 'text-red-400',
    THRESHOLD: 60,
  },
  RT_ROTTEN: {
    BG: 'bg-green-600/20',
    TEXT: 'text-green-400',
    ICON: 'text-green-400',
  },
  TMDB: {
    BG: 'bg-blue-600/20',
    TEXT: 'text-blue-400',
    ICON: 'text-blue-400',
  },
};

export function getRTColorScheme(rating) {
  return rating >= RATING_COLORS.RT_FRESH.THRESHOLD 
    ? RATING_COLORS.RT_FRESH 
    : RATING_COLORS.RT_ROTTEN;
}

export const REVIEW_TEMPLATE_WORDS = {
  negative: [
    'Nuobodžios scenos',
    'Lėtas tempas',
    'Nuspėjamas siužetas',
    'Blankūs personažai',
    'Prasta vaidyba',
    'Silpni dialogai',
    'Per daug klišių',
    'Paviršutiniškas turinys',
    'Perilga trukmė',
    'Prasta kinematografija'
  ],
  positive: [
    'Įtraukiantis siužetas',
    'Stipri vaidyba',
    'Nuostabi kinematografija',
    'Netikėti posūkiai',
    'Gilus emocinis poveikis',
    'Charizmatiški personažai',
    'Greitas tempas',
    'Įkvepianti istorija',
    'Puikus garso takelis',
    'Išskirtinė režisūra'
  ]
};

export function getTemplateWords(rating, threshold = 3) {
  return rating < threshold 
    ? REVIEW_TEMPLATE_WORDS.negative 
    : REVIEW_TEMPLATE_WORDS.positive;
}
